import { Component, forwardRef, Inject } from '@angular/core';
import { FeedbackSentComponent } from './feedback-sent.component';

@Component({
    selector: 'feedback-sent-body',
    templateUrl: './feedback-sent-body.component.html',
    styleUrls: ['./feedback-sent-body.component.less']
})
export class FeedbackSentBodyComponent {
    private closed: boolean = false;

    constructor( @Inject(forwardRef(() => FeedbackSentComponent)) private parent: FeedbackSentComponent) {
    }

    ngOnInit() {
        window.setTimeout(() => {
            if (!this.closed) {
                this.closed = true;
                this.parent.close();
            }
        }, 3000);
    }

    handleBodyClick() {
        if (!this.closed) {
            this.closed = true;
            this.parent.close();
        }
    }
}
